import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import FoodBeverageSection from './FoodBeverageSection';
import RestroomsSection from './RestroomsSection';
import AlcoholSection from './AlcoholSection';
import FurnitureSection from './FurnitureSection';
import EventActivitiesSection from './EventActivitiesSection';
import AVMusicSection from './AVMusicSection';
import EventRulesSection from './EventRulesSection';
import { displaySections, AVOptionsSelected, activitiesNotAllowed } from './data/utils';
import { EVENT_FAQ_CONST } from './data/constants';

const EventFAQSummary = ({ faqData })=> {
  const { FOOD_BEVERAGE_RULES, FOOD_PREP_RULES, HAS_FLEXIBLE_HOURS, OTHER_PROHIBITED_ACTIVITY } = EVENT_FAQ_CONST;
  const { has_quiet_hours: hasQuietHours } = faqData;
  const hasValidEndTime = hasQuietHours && 'object' === typeof faqData.loud_music_ends_by;
  const hasFlexibleHours = faqData.hasOwnProperty(HAS_FLEXIBLE_HOURS);
  const expandedSectionsToDisplay = [];
  if (faqData[FOOD_BEVERAGE_RULES] || faqData[FOOD_PREP_RULES]) {
    expandedSectionsToDisplay.push(<FoodBeverageSection faqData={faqData} expanded />);
  }
  if (displaySections.displayAlcoholSection(faqData)) {
    expandedSectionsToDisplay.push(<AlcoholSection faqData={faqData} expanded />);
  }
  if (displaySections.displayFurnitureSection(faqData)) {
    expandedSectionsToDisplay.push(<FurnitureSection faqData={faqData} expanded />);
  }
  if (0 < AVOptionsSelected(faqData).length) {
    expandedSectionsToDisplay.push(<AVMusicSection faqData={faqData} expanded />);
  }
  if (hasValidEndTime || hasFlexibleHours) {
    expandedSectionsToDisplay.push(<EventRulesSection faqData={faqData} expanded />);
  }
  if (0 < activitiesNotAllowed(faqData).length || faqData[OTHER_PROHIBITED_ACTIVITY]) {
    expandedSectionsToDisplay.push(<EventActivitiesSection faqData={faqData} expanded />);
  }
  if (displaySections.displayRestroomSection(faqData)) {
    expandedSectionsToDisplay.push(<RestroomsSection faqData={faqData} expanded />);
  }

  return (
    <div className="margin-xl-top">
      {expandedSectionsToDisplay.slice(0, 3).map((section, key) => (
        <div key={key}>
          <hr className="margin-no-top margin-lg-bottom" />
          <div>{section}</div>
        </div>
      ))}
    </div>
  );
};

EventFAQSummary.propTypes = {
  faqData: PropTypes.object,
  intl: intlShape,
  parkingInfo: PropTypes.object,
  listingRules: PropTypes.object
};

export default injectIntl(EventFAQSummary);
